import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AiPrompt } from 'app/Model/aiprompt';
import { AiPromptsService } from 'app/Services/aiprompt.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { LoginService } from 'app/Services/login.service';
import { UpdateTemplateService } from 'app/Services/updateTemplate.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SelectionChangedEvent, ValueChangedEvent } from 'devextreme/ui/select_box';
import { TemplateItemTemplate } from '../../../Model/Catalog/TemplateItemTemplate';
import { ArrayStore, DataSource } from 'devextreme/common/data';
@Component({
  selector: 'aiprompt-editor',
  templateUrl: './aiprompt-editor.component.html'
})
export class AipromptEditorComponent implements OnInit {
  @Input() prompt: AiPrompt = new AiPrompt();
  @Output() promptChange = new EventEmitter<string>();

  models: { model: string; client: string }[] = [];
  selectedModel: { model: string; client: string };

  selectedTemplateItemField;
  fields : {field:  string, groupp: string, translation:string}[] =[];
  fieldGroups : {key: string, items: string[]}[] = [];

  dataSource;

  constructor(
    public aiPromptsService: AiPromptsService,
    public loginService: LoginService,
    public translate: TranslateService,
    public updateTemplateService: UpdateTemplateService,
    public catalogService: CatalogService
  ) {}

  async ngOnInit() {
    this.aiPromptsService.getModels(this.loginService.currentCustomer.id).then(x=>{
      this.models = x;
      this.selectedModel = this.models.find((x) => x.client == this.prompt.client && x.model == this.prompt.model);
    });

    this.fields = await this.aiPromptsService.getFieldsWithGroups(this.loginService.currentCustomer.id) as any;
    this.fields.forEach((x) => {
      x.translation = this.translate.instant(x.field);
    });

     this.dataSource = new DataSource({
      store: new ArrayStore({
        data: this.fields,
        key: 'field',
      }),
      group: 'group',
    });
  }



  onModelChanged(e: ValueChangedEvent) {
    if (e.value) {
      this.prompt.model = e.value.model;
      this.prompt.client = e.value.client;
    }
  }

  displayExprFn(item: any) {
    if (!item) return '';
    return `${item.client} | ${item.model}`;
  }

  generatePlaceholder() {
    this.prompt.prompt ??= "";   
    this.prompt.prompt += '[' + this.selectedTemplateItemField.field + ']';    
  }
}
